exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-982dcd80] {\n    font-size: 12px;\n    font-family: Arial, Helvetica, sans-serif;\n    padding: 0 0.25em !important;\n    background-color: #fff !important;\n    border-radius: 1px !important;\n    color: rgb(208, 49, 49) !important;\n    height: 25px;\n    border: 1px solid rgba(60, 60, 60, .26) !important;\n}\n", ""]);

// exports
